import { render, staticRenderFns } from "./userActionReasonModal.vue?vue&type=template&id=dcddf45e&"
import script from "./userActionReasonModal.vue?vue&type=script&lang=js&"
export * from "./userActionReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports